<template>
  <div class="customermatchview" :class="cssClass">
    <font-awesome-icon v-if="!match.match.isNonIdent" icon="user" class="identuser" :title="$t('customerSearch.isIdent')" />
    <div class="row">
      <div class="col-8 col-xl-5">
        <div class="friendcontainer">
          <div class="friendimage">
            <friendicon :image="match.match.portrait" :friendname="match.match.firstName" :state="friendshipState" :multiple-friendships="match.match.multipleCustomers" />
          </div>
          <div class="friendinfo">
            <div class="friendname">
              <a href="javascript:void(0)" @click="onVolunteerSelected">
                {{ match.match.firstName }} {{ match.match.lastName }}
              </a>
            </div>
            <div class="frienddetails">
              <div class="age">
                {{ genderAgeText }}
              </div>
              <div class="area">
                {{ section }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none d-xl-block col-xl-4">
        <div class="description-container">
          <div v-show="match.match.shortDescription" class="description">
            &#8220;{{ match.match.shortDescription }}&#8221;
          </div>
        </div>
      </div>
      <div class="col-4 col-xl-3 starblock">
        <div class="customercontainer justify-content-right">
          <div v-if="match.isInappropriateMatch" class="inappropriatelabel">
            {{ $t('customerSearch.inappropriate') }}
          </div>
          <stars v-else :score="match.score" :is-net="isNetItem" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 nocustomer">
        {{ daysWithoutFriend(match.match.lastFriendshipEndDate) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue'
  import { LocaleMessage } from 'vue-i18n'
  import * as _ from 'lodash'
  import friendicon from './FriendIcon.vue'
  import stars from '../SPRStars.vue'
  import datehelper from '../../mixins/dates.js'
  import enumhelper from '../../mixins/enums.js'
  import { MatchItemNetVolunteerDto, MatchItemStandardVolunteerDto, CustomerState } from '../../types/index'

  export default Vue.extend({
    name: 'CustomerMatchView',
    components: { friendicon, stars },
    mixins: [enumhelper, datehelper],
    props: {
      match: {
        type: Object as () => MatchItemNetVolunteerDto | MatchItemStandardVolunteerDto,
        required: true
      }
    },
    computed: {
      cssClass (): string {
        return this.match.isInappropriateMatch ? 'inappropriate' : ''
      },
      isNetItem (): boolean {
        return this.isMatchItemNetVolunteer(this.match)
      },
      computedGender (): string | LocaleMessage {
        // @ts-ignore (cant find mixin)
        return this.getGenderTranslation(this.match.match.gender)
      },
      computedAge (): number {
        // @ts-ignore (cant find mixin)
        return this.calculateAge(this.match.match.birthDate)
      },
      genderAgeText (): string {
        return [this.computedGender, this.computedAge ? `${this.computedAge} ${this.$t('customerSearch.years')}` : ''].filter(Boolean).join(', ')
      },
      friendshipState (): CustomerState {
        return this.match.match.state
      },
      section (): string {
        var section = _.find(this.$store.state.sections, (s) => {
          return s.id === this.match.match.sectionId
        })

        return (section ? section.name : '') + this.isNetItem ? ' (' + this.match.match.zipCode + ')' : ''
      }
    },
    methods: {
      onVolunteerSelected (): void {
        this.$emit('volunteerSelected', this.match)
      },
      daysWithoutFriend (lastFriendshipDate): string {
        if (!lastFriendshipDate) {
          return `${this.$t('customerSearch.neverHadFriend')}`
        }
        if (this.match.match.state === CustomerState.ActiveFriendship) { //this might not be the most accurate, as we've seen before that the state can be ActiveFriendhsip even if the profile has no friendships
          // @ts-ignore (mixin not found)
          return `${this.$t('customerSearch.hasActiveFriendship')}` // we might want to change this to a different message in the future
        }
        // @ts-ignore (no mixins found)
        return `${this.calculateDayDiff(lastFriendshipDate)} ${this.$t('customerSearch.daysWithoutFriend')}`
      },
      isMatchItemNetVolunteer (match: MatchItemNetVolunteerDto | MatchItemStandardVolunteerDto): match is MatchItemNetVolunteerDto {
        return (match as MatchItemNetVolunteerDto).match.friendVolunteerProfileNetId !== undefined
      }
    }
  })
</script>
<style lang="scss">
  @import "../../assets/scss/_variables.scss";

  .customermatchview {
    background-color: $brand-white;
    border-left: solid 5px $volunteer-color-strong;
    margin-bottom: 10px;
    padding: 10px;
    position: relative;

    .identuser {
      position: absolute;
      top: 5px;
      left: 5px;
      color: $brand-red;
    }

    .starblock {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    .customercontainer {
      .identuser {
        position: absolute;
        right: 20px;
        color: $brand-red;
      }
      .customerimage {
        float: right;
        margin-left: 5px;
      }
      .summary {
        font-size: 13px;
        display: inline-block;
        text-align: right;
        .customername {
          text-transform: uppercase;
          color: $brand-red;
          font-weight: bold;
          display: block;
        }
      }

    }
    .nocustomer {
        text-align: center;
        font-size: 13px;
      }
    &.inappropriate {
      color: $brand-grey6;
      background-color: $brand-grey3;

      .friendinfo {
        .friendname a {
          color: $brand-grey8;
        }
      }

      .friendimage .friendicon {
        background-color: $brand-grey6;
      }

      .inappropriatelabel {
        font-size: 13px;
        font-weight: bold;
        text-transform: uppercase;
        color: $brand-grey8;
        text-align: center;
      }
    }
  }

  .description-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .description {
      color: $brand-red;
      font-style: italic;
      font-size: 13px;
      text-align: center;
      align-self: center;
    }
  }

  .friendcontainer {
    display: flex;
    align-items: center;
    .friendinfo {
      align-items: center;
      font-size: 13px;
      display: inline-block;
      text-align: left;
      .friendname {
        display: block;
        a {
          color: $brand-red;
          text-transform: uppercase;
          font-weight: bold;
        }
      }
    }
    .friendimage {
      align-items: center;
      display: inline-block;
      margin-right: 5px;
    }
  }
</style>